import notFoundIcon from '@assets/svg/icon/not-found.svg';
import ToastCollectionService from '@Containers/ToastMessages/ToastCollectionService';

import { badNetTitle, websocketsAreUnstableMsg } from '../ToastMessagesConstants';

export function newToastMessage(data) {
  return ToastCollectionService.showToast(data);
}

export function newToastMessageAsync(...args) {
  newToastMessage(...args);

  return new Promise((res) => {
    setTimeout(res, 300);
  });
}

export function removeToastMessage(id) {
  return ToastCollectionService.removeToast(id);
}

export function websocketsAreUnstableToastMessage() {
  return newToastMessage({
    title: badNetTitle,
    content: websocketsAreUnstableMsg,
    iconId: notFoundIcon.url,
  });
}
